import AppPlateFormLogos from "components/appplateformlogos";

const FacebookIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.14011 14.1157V8.94039H10.8861L11.1456 6.91407H9.14011V5.6234C9.14011 5.03867 9.30302 4.63834 10.1422 4.63834H11.2056V2.83177C10.6882 2.77632 10.1681 2.74955 9.64779 2.75157C8.10454 2.75157 7.04497 3.69369 7.04497 5.42323V6.91029H5.31038V8.9366H7.04875V14.1157H9.14011Z"
        fill="#3A7789"
      />
    </svg>
  );
};

const InstagramIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4248 3.70649C12.7111 3.99268 12.9345 4.33549 13.0807 4.71298C13.2492 5.16084 13.3391 5.63444 13.3465 6.1129C13.3819 6.71718 13.3819 6.91294 13.3819 8.45545V8.45557C13.3819 9.9982 13.3736 10.1908 13.3465 10.7982C13.337 11.2706 13.248 11.7366 13.0819 12.1786C12.9355 12.556 12.7121 12.8988 12.4258 13.1851C12.1396 13.4714 11.7968 13.6948 11.4193 13.8412C10.9774 14.0067 10.5107 14.0962 10.039 14.1058C9.43594 14.1405 9.23829 14.1405 7.6963 14.1405C6.1543 14.1405 5.96171 14.1323 5.35363 14.1058C4.88091 14.0902 4.41431 13.9941 3.97391 13.8216C3.59635 13.6755 3.25342 13.4522 2.96703 13.166C2.68064 12.8799 2.4571 12.5371 2.31068 12.1596C2.14461 11.717 2.05557 11.251 2.0461 10.7787C2.01074 10.1744 2.01074 9.97799 2.01074 8.436C2.01074 6.89337 2.01895 6.70078 2.0461 6.09333C2.05533 5.62153 2.1448 5.15475 2.31068 4.71298C2.45669 4.33539 2.68002 3.99249 2.96633 3.70629C3.25265 3.42008 3.59564 3.19688 3.97328 3.05102C4.41451 2.88469 4.88092 2.795 5.35236 2.78581C5.9554 2.75171 6.15304 2.75171 7.69503 2.75171C9.23703 2.75171 9.42962 2.75929 10.0377 2.78581C10.5095 2.79549 10.9762 2.88517 11.4181 3.05102C11.7956 3.19705 12.1385 3.42031 12.4248 3.70649ZM12.1152 11.7978C12.2411 11.4564 12.3075 11.0958 12.3115 10.7319V10.7326H12.3185C12.3456 10.1289 12.3456 9.96347 12.3456 8.42526C12.3456 6.88643 12.3387 6.71783 12.3115 6.11732C12.3057 5.7575 12.2393 5.40123 12.1152 5.06344C12.0203 4.81785 11.8751 4.59481 11.6889 4.40865C11.5028 4.22248 11.2797 4.07729 11.0341 3.9824C10.6965 3.85679 10.3398 3.79035 9.97961 3.78602C9.369 3.75129 9.21114 3.75129 7.6723 3.75129C6.13346 3.75129 5.96487 3.75887 5.36436 3.78602C5.00445 3.79105 4.64804 3.85746 4.31047 3.9824C3.81226 4.1731 3.41761 4.56523 3.22502 5.06344C3.09914 5.40468 3.03272 5.76499 3.02864 6.12869C2.99517 6.74056 2.99517 6.89779 2.99517 8.43663C2.99517 9.97484 3.00148 10.1441 3.02864 10.7439C3.03452 11.1038 3.1009 11.46 3.22502 11.7978C3.32026 12.0438 3.46609 12.2671 3.65307 12.4532C3.84005 12.6394 4.06401 12.7841 4.31047 12.8782C4.64787 13.0038 5.00439 13.0702 5.36436 13.0746C5.9756 13.1093 6.13283 13.1093 7.6723 13.1093C9.21051 13.1093 9.37974 13.1024 9.97961 13.0746C10.3398 13.07 10.6964 13.0035 11.0341 12.8782C11.2797 12.7835 11.5028 12.6385 11.689 12.4524C11.8752 12.2664 12.0203 12.0434 12.1152 11.7978ZM10.7282 6.08232C11.1041 6.08232 11.4089 5.77756 11.4089 5.40162C11.4089 5.02568 11.1041 4.72092 10.7282 4.72092C10.3522 4.72092 10.0475 5.02568 10.0475 5.40162C10.0475 5.77756 10.3522 6.08232 10.7282 6.08232ZM7.69082 5.51197C6.91643 5.51197 6.17377 5.81959 5.6262 6.36716C5.07863 6.91474 4.771 7.6574 4.771 8.43178C4.771 9.20617 5.07863 9.94883 5.6262 10.4964C6.17377 11.044 6.91643 11.3516 7.69082 11.3516C8.4652 11.3516 9.20787 11.044 9.75544 10.4964C10.303 9.94883 10.6106 9.20617 10.6106 8.43178C10.6106 7.6574 10.303 6.91474 9.75544 6.36716C9.20787 5.81959 8.4652 5.51197 7.69082 5.51197ZM7.69082 10.328C7.18774 10.328 6.70526 10.1282 6.34953 9.77244C5.9938 9.41671 5.79395 8.93423 5.79395 8.43115C5.79395 7.92807 5.9938 7.4456 6.34953 7.08986C6.70526 6.73413 7.18774 6.53428 7.69082 6.53428C8.1939 6.53428 8.67637 6.73413 9.03211 7.08986C9.38784 7.4456 9.58769 7.92807 9.58769 8.43115C9.58769 8.93423 9.38784 9.41671 9.03211 9.77244C8.67637 10.1282 8.1939 10.328 7.69082 10.328Z"
        fill="#3A7789"
      />
    </svg>
  );
};

const WhatsppIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5996 3.95787C11.4188 2.77075 9.8465 2.12036 8.17317 2.12036C4.72546 2.12036 1.91552 4.9303 1.91552 8.37801C1.91552 9.48304 2.20599 10.5565 2.74903 11.5037L1.86501 14.7493L5.18011 13.8779C6.0957 14.3768 7.12496 14.642 8.17317 14.642C11.6209 14.642 14.4308 11.832 14.4308 8.38432C14.4308 6.71099 13.7804 5.13868 12.5996 3.95787ZM8.17317 13.5811C7.23862 13.5811 6.32303 13.3286 5.52109 12.855L5.33165 12.7413L3.36154 13.2591L3.88564 11.3395L3.75935 11.1437C3.24156 10.3166 2.96372 9.35675 2.96372 8.37801C2.96372 5.51123 5.30008 3.17488 8.16685 3.17488C9.55604 3.17488 10.8631 3.71792 11.8419 4.70298C12.8269 5.68804 13.3637 6.99514 13.3637 8.38432C13.3763 11.2511 11.0399 13.5811 8.17317 13.5811ZM11.0273 9.69142C10.8694 9.61564 10.0991 9.23678 9.96016 9.17994C9.81493 9.12943 9.7139 9.10417 9.60655 9.25572C9.49921 9.41358 9.20243 9.76719 9.11402 9.86822C9.02562 9.97557 8.9309 9.9882 8.77304 9.90611C8.61518 9.83034 8.11002 9.65985 7.51646 9.12943C7.04919 8.71267 6.73978 8.2012 6.64506 8.04334C6.55666 7.88548 6.63243 7.80339 6.71452 7.7213C6.78398 7.65184 6.87239 7.53818 6.94816 7.44978C7.02393 7.36138 7.0555 7.29192 7.10602 7.19089C7.15654 7.08354 7.13128 6.99514 7.09339 6.91936C7.0555 6.84359 6.73978 6.07322 6.61349 5.7575C6.4872 5.4544 6.3546 5.49229 6.25988 5.48598C6.16516 5.48598 6.06413 5.48598 5.95679 5.48598C5.84944 5.48598 5.68526 5.52386 5.54003 5.68173C5.40111 5.83959 4.99699 6.21846 4.99699 6.98882C4.99699 7.75919 5.55897 8.5043 5.63475 8.60533C5.71052 8.71267 6.73978 10.2913 8.30577 10.9669C8.67833 11.1311 8.96879 11.2258 9.19611 11.2953C9.56867 11.4153 9.90965 11.3963 10.1812 11.3584C10.4843 11.3142 11.1094 10.9796 11.2357 10.6133C11.3683 10.2471 11.3683 9.93768 11.3241 9.86822C11.2799 9.79876 11.1852 9.76719 11.0273 9.69142Z"
        fill="#3A7789"
      />
    </svg>
  );
};

const socialMediaLinks = [
  { id: 0, icon: <FacebookIcon />, link: "https://www.facebook.com/share/15Lb3EEoBv/?mibextid=LQQJ4d", title: "Facebook" },
  { id: 1, icon: <InstagramIcon />, link: "https://www.instagram.com/surpeats", title: "Instagram" },
  { id: 2, icon: <WhatsppIcon />, link: "https://wa.me/919920277081", title: "Whatsapp" },
];

const footerMenu = [
  { id: 0, label: "Home", link: "/" },
  { id: 1, label: "How it Works", link: "/howitworks" },
  { id: 2, label: "For Partner", link: "/partner" },
  { id: 3, label: "Policy for partners", link: "/PrivacyPolicyForPartners" },
  { id: 3, label: "Policy for user", link: "/PrivacyPolicyForUser" },
  { id: 3, label: "User agreement", link: "/UserAgreement" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-200 py-10 md:py-14 text-white">
      <div className="container">
        <div className="border-y border-white py-14 md:py-11 flex items-center justify-between gap-6 flex-wrap">
          <ul className="text-white space-y-4">
            <li>
              <a href="/" title="Surpeats">
                <img alt="Surpeats" src="images/surpeats-logo.svg" />
              </a>
            </li>
            <li className="mb-4">
              <span className="block text-base font-medium mb-1">Address</span>
              <span className="block text-base font-medium">
              Jesal Park Rd, Bhayandar, Jesal Park, Bhayandar East, Mira Bhayandar, Maharashtra 401105
              </span>
            </li>
            <li className="mb-4">
              <span className="block text-base font-medium mb-1">Email</span>
              <a
                href="mailto:admin@surpeats.com"
                title="admin@surpeats.com"
                className="block text-base font-medium"
              >
                admin@surpeats.com
              </a>
            </li>
            <li>
              <span className="block text-base font-medium mb-1">
                Phone Number
              </span>
              <a
                href="tel:+919920277081"
                title=""
                className="block text-base font-medium"
              >
                +919920277081
              </a>
            </li>
          </ul>

          <ul className="space-y-6">
            {footerMenu.map((item, index) => {
              return (
                <li key={`footer-link-${index}`}>
                  <a
                    href={item.link}
                    title={item.label}
                    className="text-base font-medium transition-colors hover:text-blue-100"
                  >
                    {item.label}
                  </a>
                </li>
              );
            })}
          </ul>

          <div className="max-w-[350px] w-full">
            <form className="mb-8">
              <label className="block text-base text-white mb-3">
                Let's Stay in Touch
              </label>
              <div className="relative">
                <input
                  className="text-base text-black placeholder:text-black py-2.5 pl-4 pr-32 outline-none w-full rounded-full"
                  placeholder="Enter Your Email Address"
                />
                <button
                  type="button"
                  className="absolute px-7 py-2.5 outline-none bg-primary-200 inset-y-0 -right-px text-white transition-colors hover:bg-blue-100 rounded-full"
                >
                  Subscribe
                </button>
              </div>
            </form>
            <div className="lg:mb-10">
              <span className="block mb-3">Follow our Social</span>
              <div className="flex items-center gap-3">
                {socialMediaLinks.map((item, index) => {
                  return (
                    <a
                      href={item.link}
                      key={`footer-${index}`}
                      title={item.title}
                      className="rounded-full bg-white size-7 flex items-center justify-center transition-colors hover:bg-blue-100"
                    >
                      {item.icon}
                    </a>
                  );
                })}
              </div>
            </div>
            <AppPlateFormLogos className="!hidden lg:flex" />
          </div>
        </div>
      </div>

      <p className="text-center text-base font-medium pt-7">
        © 2024 Surpeats. All rights reserved.
      </p>
    </footer>
  );
}
